!(function (n, e) {
  if (typeof window === 'undefined') return
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = e())
    : 'function' == typeof define && define.amd
      ? define('postRobot', [], e)
      : 'object' == typeof exports
        ? (exports.postRobot = e())
        : (n.postRobot = e())
})('undefined' != typeof self ? self : this, function () {
  return (function (n) {
    var e = {}
    function t(r) {
      if (e[r]) return e[r].exports
      var o = (e[r] = { i: r, l: !1, exports: {} })
      return n[r].call(o.exports, o, o.exports, t), (o.l = !0), o.exports
    }
    return (
      (t.m = n),
      (t.c = e),
      (t.d = function (n, e, r) {
        t.o(n, e) || Object.defineProperty(n, e, { enumerable: !0, get: r })
      }),
      (t.r = function (n) {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(n, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(n, '__esModule', { value: !0 })
      }),
      (t.t = function (n, e) {
        if ((1 & e && (n = t(n)), 8 & e)) return n
        if (4 & e && 'object' == typeof n && n && n.__esModule) return n
        var r = Object.create(null)
        if (
          (t.r(r),
          Object.defineProperty(r, 'default', { enumerable: !0, value: n }),
          2 & e && 'string' != typeof n)
        )
          for (var o in n)
            t.d(
              r,
              o,
              function (e) {
                return n[e]
              }.bind(null, o),
            )
        return r
      }),
      (t.n = function (n) {
        var e =
          n && n.__esModule
            ? function () {
                return n.default
              }
            : function () {
                return n
              }
        return t.d(e, 'a', e), e
      }),
      (t.o = function (n, e) {
        return {}.hasOwnProperty.call(n, e)
      }),
      (t.p = ''),
      t((t.s = 0))
    )
  })([
    function (n, e, t) {
      'use strict'
      function r(n) {
        return '[object RegExp]' === {}.toString.call(n)
      }
      t.r(e),
        t.d(e, 'Promise', function () {
          return z
        }),
        t.d(e, 'TYPES', function () {
          return Qn
        }),
        t.d(e, 'ProxyWindow', function () {
          return Sn
        }),
        t.d(e, 'setup', function () {
          return $n
        }),
        t.d(e, 'destroy', function () {
          return Gn
        }),
        t.d(e, 'serializeMessage', function () {
          return Un
        }),
        t.d(e, 'deserializeMessage', function () {
          return Kn
        }),
        t.d(e, 'createProxyWindow', function () {
          return Yn
        }),
        t.d(e, 'toProxyWindow', function () {
          return Zn
        }),
        t.d(e, 'on', function () {
          return Bn
        }),
        t.d(e, 'once', function () {
          return Hn
        }),
        t.d(e, 'send', function () {
          return Jn
        }),
        t.d(e, 'markWindowKnown', function () {
          return vn
        }),
        t.d(e, 'cleanUpWindow', function () {
          return Vn
        }),
        t.d(e, 'bridge', function () {})
      var o = 'Call was rejected by callee.\r\n'
      function i(n) {
        return void 0 === n && (n = window), n.location.protocol
      }
      function a(n) {
        if ((void 0 === n && (n = window), n.mockDomain)) {
          var e = n.mockDomain.split('//')[0]
          if (e) return e
        }
        return i(n)
      }
      function u(n) {
        return void 0 === n && (n = window), 'about:' === a(n)
      }
      function c(n) {
        if ((void 0 === n && (n = window), n))
          try {
            if (n.parent && n.parent !== n) return n.parent
          } catch (n) {}
      }
      function s(n) {
        if ((void 0 === n && (n = window), n && !c(n)))
          try {
            return n.opener
          } catch (n) {}
      }
      function f(n) {
        try {
          return !0
        } catch (n) {}
        return !1
      }
      function d(n) {
        void 0 === n && (n = window)
        var e = n.location
        if (!e) throw new Error('Can not read window location')
        var t = i(n)
        if (!t) throw new Error('Can not read window protocol')
        if ('file:' === t) return 'file://'
        if ('about:' === t) {
          var r = c(n)
          return r && f() ? d(r) : 'about://'
        }
        var o = e.host
        if (!o) throw new Error('Can not read window host')
        return t + '//' + o
      }
      function l(n) {
        void 0 === n && (n = window)
        var e = d(n)
        return e && n.mockDomain && 0 === n.mockDomain.indexOf('mock:') ? n.mockDomain : e
      }
      function h(n) {
        if (
          !(function (n) {
            try {
              if (n === window) return !0
            } catch (n) {}
            try {
              var e = Object.getOwnPropertyDescriptor(n, 'location')
              if (e && !1 === e.enumerable) return !1
            } catch (n) {}
            try {
              if (u(n) && f()) return !0
            } catch (n) {}
            try {
              if (
                (function (n) {
                  return void 0 === n && (n = window), 'mock:' === a(n)
                })(n) &&
                f()
              )
                return !0
            } catch (n) {}
            try {
              if (d(n) === d(window)) return !0
            } catch (n) {}
            return !1
          })(n)
        )
          return !1
        try {
          if (n === window) return !0
          if (u(n) && f()) return !0
          if (l(window) === l(n)) return !0
        } catch (n) {}
        return !1
      }
      function w(n) {
        if (!h(n)) throw new Error('Expected window to be same domain')
        return n
      }
      function v(n, e) {
        if (!n || !e) return !1
        var t = c(e)
        return t
          ? t === n
          : -1 !==
              (function (n) {
                var e = []
                try {
                  for (; n.parent !== n; ) e.push(n.parent), (n = n.parent)
                } catch (n) {}
                return e
              })(e).indexOf(n)
      }
      function p(n) {
        var e,
          t,
          r = []
        try {
          e = n.frames
        } catch (t) {
          e = n
        }
        try {
          t = e.length
        } catch (n) {}
        if (0 === t) return r
        if (t) {
          for (var o = 0; o < t; o++) {
            var i = void 0
            try {
              i = e[o]
            } catch (n) {
              continue
            }
            r.push(i)
          }
          return r
        }
        for (var a = 0; a < 100; a++) {
          var u = void 0
          try {
            u = e[a]
          } catch (n) {
            return r
          }
          if (!u) return r
          r.push(u)
        }
        return r
      }
      var m = [],
        y = []
      function g(n, e) {
        void 0 === e && (e = !0)
        try {
          if (n === window) return !1
        } catch (n) {
          return !0
        }
        try {
          if (!n) return !0
        } catch (n) {
          return !0
        }
        try {
          if (n.closed) return !0
        } catch (n) {
          return !n || n.message !== o
        }
        if (e && h(n))
          try {
            if (n.mockclosed) return !0
          } catch (n) {}
        try {
          if (!n.parent || !n.top) return !0
        } catch (n) {}
        var t = (function (n, e) {
          for (var t = 0; t < n.length; t++)
            try {
              if (n[t] === e) return t
            } catch (n) {}
          return -1
        })(m, n)
        if (-1 !== t) {
          var r = y[t]
          if (
            r &&
            (function (n) {
              if (!n.contentWindow) return !0
              if (!n.parentNode) return !0
              var e = n.ownerDocument
              if (e && e.documentElement && !e.documentElement.contains(n)) {
                for (var t = n; t.parentNode && t.parentNode !== t; ) t = t.parentNode
                if (!t.host || !e.documentElement.contains(t.host)) return !0
              }
              return !1
            })(r)
          )
            return !0
        }
        return !1
      }
      function _(n) {
        return void 0 === n && (n = window), s((n = n || window)) || c(n) || void 0
      }
      function b(n, e) {
        if ('string' == typeof n) {
          if ('string' == typeof e) return '*' === n || e === n
          if (r(e)) return !1
          if (Array.isArray(e)) return !1
        }
        return r(n)
          ? r(e)
            ? n.toString() === e.toString()
            : !Array.isArray(e) && Boolean(e.match(n))
          : !!Array.isArray(n) &&
              (Array.isArray(e)
                ? JSON.stringify(n) === JSON.stringify(e)
                : !r(e) &&
                  n.some(function (n) {
                    return b(n, e)
                  }))
      }
      function W(n) {
        try {
          if (n === window) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if ('[object Window]' === {}.toString.call(n)) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if (window.Window && n instanceof window.Window) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if (n && n.self === n) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if (n && n.parent === n) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if (n && n.top === n) return !0
        } catch (n) {
          if (n && n.message === o) return !0
        }
        try {
          if (n && '__unlikely_value__' === n.__cross_domain_utils_window_check__) return !1
        } catch (n) {
          return !0
        }
        try {
          if ('postMessage' in n && 'self' in n && 'location' in n) return !0
        } catch (n) {}
        return !1
      }
      function E(n) {
        if (h(n)) return w(n).frameElement
        for (var e = 0, t = document.querySelectorAll('iframe'); e < t.length; e++) {
          var r = t[e]
          if (r && r.contentWindow && r.contentWindow === n) return r
        }
      }
      function x(n) {
        if (
          (function (n) {
            return void 0 === n && (n = window), Boolean(c(n))
          })(n)
        ) {
          var e = E(n)
          if (e && e.parentElement) return void e.parentElement.removeChild(e)
        }
        try {
          n.close()
        } catch (n) {}
      }
      function j(n) {
        try {
          if (!n) return !1
          if ('undefined' != typeof Promise && n instanceof Promise) return !0
          if (
            'undefined' != typeof window &&
            'function' == typeof window.Window &&
            n instanceof window.Window
          )
            return !1
          if (
            'undefined' != typeof window &&
            'function' == typeof window.constructor &&
            n instanceof window.constructor
          )
            return !1
          var e = {}.toString
          if (e) {
            var t = e.call(n)
            if ('[object Window]' === t || '[object global]' === t || '[object DOMWindow]' === t)
              return !1
          }
          if ('function' == typeof n.then) return !0
        } catch (n) {
          return !1
        }
        return !1
      }
      var S,
        k = [],
        O = [],
        P = 0
      function A() {
        if (!P && S) {
          var n = S
          ;(S = null), n.resolve()
        }
      }
      function D() {
        P += 1
      }
      function I() {
        ;(P -= 1), A()
      }
      var z = (function () {
        function n(n) {
          var e = this
          if (
            ((this.resolved = void 0),
            (this.rejected = void 0),
            (this.errorHandled = void 0),
            (this.value = void 0),
            (this.error = void 0),
            (this.handlers = void 0),
            (this.dispatching = void 0),
            (this.stack = void 0),
            (this.resolved = !1),
            (this.rejected = !1),
            (this.errorHandled = !1),
            (this.handlers = []),
            n)
          ) {
            var t,
              r,
              o = !1,
              i = !1,
              a = !1
            D()
            try {
              n(
                function (n) {
                  a ? e.resolve(n) : ((o = !0), (t = n))
                },
                function (n) {
                  a ? e.reject(n) : ((i = !0), (r = n))
                },
              )
            } catch (n) {
              return I(), void this.reject(n)
            }
            I(), (a = !0), o ? this.resolve(t) : i && this.reject(r)
          }
        }
        var e = n.prototype
        return (
          (e.resolve = function (n) {
            if (this.resolved || this.rejected) return this
            if (j(n)) throw new Error('Can not resolve promise with another promise')
            return (this.resolved = !0), (this.value = n), this.dispatch(), this
          }),
          (e.reject = function (n) {
            var e = this
            if (this.resolved || this.rejected) return this
            if (j(n)) throw new Error('Can not reject promise with another promise')
            if (!n) {
              var t = n && 'function' == typeof n.toString ? n.toString() : {}.toString.call(n)
              n = new Error('Expected reject to be called with Error, got ' + t)
            }
            return (
              (this.rejected = !0),
              (this.error = n),
              this.errorHandled ||
                setTimeout(function () {
                  e.errorHandled ||
                    (function (n, e) {
                      if (-1 === k.indexOf(n)) {
                        k.push(n),
                          setTimeout(function () {
                            throw n
                          }, 1)
                        for (var t = 0; t < O.length; t++) O[t](n, e)
                      }
                    })(n, e)
                }, 1),
              this.dispatch(),
              this
            )
          }),
          (e.asyncReject = function (n) {
            return (this.errorHandled = !0), this.reject(n), this
          }),
          (e.dispatch = function () {
            var e = this.resolved,
              t = this.rejected,
              r = this.handlers
            if (!this.dispatching && (e || t)) {
              ;(this.dispatching = !0), D()
              for (
                var o = function (n, e) {
                    return n.then(
                      function (n) {
                        e.resolve(n)
                      },
                      function (n) {
                        e.reject(n)
                      },
                    )
                  },
                  i = 0;
                i < r.length;
                i++
              ) {
                var a = r[i],
                  u = a.onSuccess,
                  c = a.onError,
                  s = a.promise,
                  f = void 0
                if (e)
                  try {
                    f = u ? u(this.value) : this.value
                  } catch (n) {
                    s.reject(n)
                    continue
                  }
                else if (t) {
                  if (!c) {
                    s.reject(this.error)
                    continue
                  }
                  try {
                    f = c(this.error)
                  } catch (n) {
                    s.reject(n)
                    continue
                  }
                }
                if (f instanceof n && (f.resolved || f.rejected)) {
                  var d = f
                  d.resolved ? s.resolve(d.value) : s.reject(d.error), (d.errorHandled = !0)
                } else
                  j(f)
                    ? f instanceof n && (f.resolved || f.rejected)
                      ? f.resolved
                        ? s.resolve(f.value)
                        : s.reject(f.error)
                      : o(f, s)
                    : s.resolve(f)
              }
              ;(r.length = 0), (this.dispatching = !1), I()
            }
          }),
          (e.then = function (e, t) {
            if (e && 'function' != typeof e && !e.call)
              throw new Error('Promise.then expected a function for success handler')
            if (t && 'function' != typeof t && !t.call)
              throw new Error('Promise.then expected a function for error handler')
            var r = new n()
            return (
              this.handlers.push({ promise: r, onSuccess: e, onError: t }),
              (this.errorHandled = !0),
              this.dispatch(),
              r
            )
          }),
          (e.catch = function (n) {
            return this.then(void 0, n)
          }),
          (e.finally = function (e) {
            if (e && 'function' != typeof e && !e.call)
              throw new Error('Promise.finally expected a function')
            return this.then(
              function (t) {
                return n.try(e).then(function () {
                  return t
                })
              },
              function (t) {
                return n.try(e).then(function () {
                  throw t
                })
              },
            )
          }),
          (e.timeout = function (n, e) {
            var t = this
            if (this.resolved || this.rejected) return this
            var r = setTimeout(function () {
              t.resolved ||
                t.rejected ||
                t.reject(e || new Error('Promise timed out after ' + n + 'ms'))
            }, n)
            return this.then(function (n) {
              return clearTimeout(r), n
            })
          }),
          (e.toPromise = function () {
            if ('undefined' == typeof Promise) throw new TypeError('Could not find Promise')
            return Promise.resolve(this)
          }),
          (e.lazy = function () {
            return (this.errorHandled = !0), this
          }),
          (n.resolve = function (e) {
            return e instanceof n
              ? e
              : j(e)
                ? new n(function (n, t) {
                    return e.then(n, t)
                  })
                : new n().resolve(e)
          }),
          (n.reject = function (e) {
            return new n().reject(e)
          }),
          (n.asyncReject = function (e) {
            return new n().asyncReject(e)
          }),
          (n.all = function (e) {
            var t = new n(),
              r = e.length,
              o = [].slice()
            if (!r) return t.resolve(o), t
            for (
              var i = function (n, e, i) {
                  return e.then(
                    function (e) {
                      ;(o[n] = e), 0 == (r -= 1) && t.resolve(o)
                    },
                    function (n) {
                      i.reject(n)
                    },
                  )
                },
                a = 0;
              a < e.length;
              a++
            ) {
              var u = e[a]
              if (u instanceof n) {
                if (u.resolved) {
                  ;(o[a] = u.value), (r -= 1)
                  continue
                }
              } else if (!j(u)) {
                ;(o[a] = u), (r -= 1)
                continue
              }
              i(a, n.resolve(u), t)
            }
            return 0 === r && t.resolve(o), t
          }),
          (n.hash = function (e) {
            var t = {},
              r = [],
              o = function (n) {
                if (e.hasOwnProperty(n)) {
                  var o = e[n]
                  j(o)
                    ? r.push(
                        o.then(function (e) {
                          t[n] = e
                        }),
                      )
                    : (t[n] = o)
                }
              }
            for (var i in e) o(i)
            return n.all(r).then(function () {
              return t
            })
          }),
          (n.map = function (e, t) {
            return n.all(e.map(t))
          }),
          (n.onPossiblyUnhandledException = function (n) {
            return (function (n) {
              return (
                O.push(n),
                {
                  cancel: function () {
                    O.splice(O.indexOf(n), 1)
                  },
                }
              )
            })(n)
          }),
          (n.try = function (e, t, r) {
            if (e && 'function' != typeof e && !e.call)
              throw new Error('Promise.try expected a function')
            var o
            D()
            try {
              o = e.apply(t, r || [])
            } catch (e) {
              return I(), n.reject(e)
            }
            return I(), n.resolve(o)
          }),
          (n.delay = function (e) {
            return new n(function (n) {
              setTimeout(n, e)
            })
          }),
          (n.isPromise = function (e) {
            return !!(e && e instanceof n) || j(e)
          }),
          (n.flush = function () {
            return (e = S = S || new n()), A(), e
            var e
          }),
          n
        )
      })()
      function C(n, e) {
        for (var t = 0; t < n.length; t++)
          try {
            if (n[t] === e) return t
          } catch (n) {}
        return -1
      }
      var N,
        M = (function () {
          function n() {
            if (
              ((this.name = void 0),
              (this.weakmap = void 0),
              (this.keys = void 0),
              (this.values = void 0),
              (this.name = '__weakmap_' + ((1e9 * Math.random()) >>> 0) + '__'),
              (function () {
                if ('undefined' == typeof WeakMap) return !1
                if (void 0 === Object.freeze) return !1
                try {
                  var n = new WeakMap(),
                    e = {}
                  return Object.freeze(e), n.set(e, '__testvalue__'), '__testvalue__' === n.get(e)
                } catch (n) {
                  return !1
                }
              })())
            )
              try {
                this.weakmap = new WeakMap()
              } catch (n) {}
            ;(this.keys = []), (this.values = [])
          }
          var e = n.prototype
          return (
            (e._cleanupClosedWindows = function () {
              for (var n = this.weakmap, e = this.keys, t = 0; t < e.length; t++) {
                var r = e[t]
                if (W(r) && g(r)) {
                  if (n)
                    try {
                      n.delete(r)
                    } catch (n) {}
                  e.splice(t, 1), this.values.splice(t, 1), (t -= 1)
                }
              }
            }),
            (e.isSafeToReadWrite = function (n) {
              return !W(n)
            }),
            (e.set = function (n, e) {
              if (!n) throw new Error('WeakMap expected key')
              var t = this.weakmap
              if (t)
                try {
                  t.set(n, e)
                } catch (n) {
                  delete this.weakmap
                }
              if (this.isSafeToReadWrite(n))
                try {
                  var r = this.name,
                    o = n[r]
                  return void (o && o[0] === n
                    ? (o[1] = e)
                    : Object.defineProperty(n, r, { value: [n, e], writable: !0 }))
                } catch (n) {}
              this._cleanupClosedWindows()
              var i = this.keys,
                a = this.values,
                u = C(i, n)
              ;-1 === u ? (i.push(n), a.push(e)) : (a[u] = e)
            }),
            (e.get = function (n) {
              if (!n) throw new Error('WeakMap expected key')
              var e = this.weakmap
              if (e)
                try {
                  if (e.has(n)) return e.get(n)
                } catch (n) {
                  delete this.weakmap
                }
              if (this.isSafeToReadWrite(n))
                try {
                  var t = n[this.name]
                  return t && t[0] === n ? t[1] : void 0
                } catch (n) {}
              this._cleanupClosedWindows()
              var r = C(this.keys, n)
              if (-1 !== r) return this.values[r]
            }),
            (e.delete = function (n) {
              if (!n) throw new Error('WeakMap expected key')
              var e = this.weakmap
              if (e)
                try {
                  e.delete(n)
                } catch (n) {
                  delete this.weakmap
                }
              if (this.isSafeToReadWrite(n))
                try {
                  var t = n[this.name]
                  t && t[0] === n && (t[0] = t[1] = void 0)
                } catch (n) {}
              this._cleanupClosedWindows()
              var r = this.keys,
                o = C(r, n)
              ;-1 !== o && (r.splice(o, 1), this.values.splice(o, 1))
            }),
            (e.has = function (n) {
              if (!n) throw new Error('WeakMap expected key')
              var e = this.weakmap
              if (e)
                try {
                  if (e.has(n)) return !0
                } catch (n) {
                  delete this.weakmap
                }
              if (this.isSafeToReadWrite(n))
                try {
                  var t = n[this.name]
                  return !(!t || t[0] !== n)
                } catch (n) {}
              return this._cleanupClosedWindows(), -1 !== C(this.keys, n)
            }),
            (e.getOrSet = function (n, e) {
              if (this.has(n)) return this.get(n)
              var t = e()
              return this.set(n, t), t
            }),
            n
          )
        })()
      function T(n) {
        return n.name || n.__name__ || n.displayName || 'anonymous'
      }
      function R(n, e) {
        try {
          delete n.name, (n.name = e)
        } catch (n) {}
        return (n.__name__ = n.displayName = e), n
      }
      function L() {
        var n = '0123456789abcdef'
        return (
          'uid_' +
          'xxxxxxxxxx'.replace(/./g, function () {
            return n.charAt(Math.floor(Math.random() * n.length))
          }) +
          '_' +
          (function (n) {
            if ('function' == typeof btoa)
              return btoa(
                encodeURIComponent(n).replace(/%([0-9A-F]{2})/g, function (n, e) {
                  return String.fromCharCode(parseInt(e, 16))
                }),
              ).replace(/[=]/g, '')
            if ('undefined' != typeof Buffer)
              return Buffer.from(n, 'utf8').toString('base64').replace(/[=]/g, '')
            throw new Error('Can not find window.btoa or Buffer')
          })(new Date().toISOString().slice(11, 19).replace('T', '.'))
            .replace(/[^a-zA-Z0-9]/g, '')
            .toLowerCase()
        )
      }
      function q(n) {
        try {
          return JSON.stringify([].slice.call(n), function (n, e) {
            return 'function' == typeof e
              ? 'memoize[' +
                  (function (n) {
                    if (
                      ((N = N || new M()),
                      null == n || ('object' != typeof n && 'function' != typeof n))
                    )
                      throw new Error('Invalid object')
                    var e = N.get(n)
                    return e || ((e = typeof n + ':' + L()), N.set(n, e)), e
                  })(e) +
                  ']'
              : ('undefined' != typeof window && e instanceof window.Element) ||
                  (null !== e &&
                    'object' == typeof e &&
                    1 === e.nodeType &&
                    'object' == typeof e.style &&
                    'object' == typeof e.ownerDocument)
                ? {}
                : e
          })
        } catch (n) {
          throw new Error('Arguments not serializable -- can not be used to memoize')
        }
      }
      function F() {
        return {}
      }
      var B = 0,
        H = 0
      function J(n, e) {
        void 0 === e && (e = {})
        var t,
          r,
          o = e.thisNamespace,
          i = void 0 !== o && o,
          a = e.time,
          u = B
        B += 1
        var c = function () {
          for (var e = arguments.length, o = new Array(e), c = 0; c < e; c++) o[c] = arguments[c]
          var s, f
          u < H && ((t = null), (r = null), (u = B), (B += 1)),
            (s = i ? (r = r || new M()).getOrSet(this, F) : (t = t || {}))
          try {
            f = q(o)
          } catch (e) {
            return n.apply(this, arguments)
          }
          var d = s[f]
          if ((d && a && Date.now() - d.time < a && (delete s[f], (d = null)), d)) return d.value
          var l = Date.now(),
            h = n.apply(this, arguments)
          return (s[f] = { time: l, value: h }), h
        }
        return (
          (c.reset = function () {
            ;(t = null), (r = null)
          }),
          R(c, (e.name || T(n)) + '::memoized')
        )
      }
      function U(n) {
        var e = {}
        function t() {
          for (
            var t = arguments, r = this, o = arguments.length, i = new Array(o), a = 0;
            a < o;
            a++
          )
            i[a] = arguments[a]
          var u = q(i)
          return (
            e.hasOwnProperty(u) ||
              (e[u] = z
                .try(function () {
                  return n.apply(r, t)
                })
                .finally(function () {
                  delete e[u]
                })),
            e[u]
          )
        }
        return (
          (t.reset = function () {
            e = {}
          }),
          R(t, T(n) + '::promiseMemoized')
        )
      }
      function K() {}
      function Y(n, e) {
        if ((void 0 === e && (e = 1), e >= 3)) return 'stringifyError stack overflow'
        try {
          if (!n) return '<unknown error: ' + {}.toString.call(n) + '>'
          if ('string' == typeof n) return n
          if (n instanceof Error) {
            var t = n && n.stack,
              r = n && n.message
            if (t && r) return -1 !== t.indexOf(r) ? t : r + '\n' + t
            if (t) return t
            if (r) return r
          }
          return n && n.toString && 'function' == typeof n.toString
            ? n.toString()
            : {}.toString.call(n)
        } catch (n) {
          return 'Error while stringifying error: ' + Y(n, e + 1)
        }
      }
      function Z(n) {
        return 'string' == typeof n
          ? n
          : n && n.toString && 'function' == typeof n.toString
            ? n.toString()
            : {}.toString.call(n)
      }
      function $(n) {
        return '[object RegExp]' === {}.toString.call(n)
      }
      function G(n, e, t) {
        if (n.hasOwnProperty(e)) return n[e]
        var r = t()
        return (n[e] = r), r
      }
      function Q() {
        var n = document.body
        if (!n) throw new Error('Body element not found')
        return n
      }
      function V() {
        return Boolean(document.body) && 'complete' === document.readyState
      }
      function X() {
        return Boolean(document.body) && 'interactive' === document.readyState
      }
      ;(J.clear = function () {
        H = B
      }),
        J(function (n) {
          if (Object.values) return Object.values(n)
          var e = []
          for (var t in n) n.hasOwnProperty(t) && e.push(n[t])
          return e
        }),
        Error,
        J(function () {
          return new z(function (n) {
            if (V() || X()) return n()
            var e = setInterval(function () {
              if (V() || X()) return clearInterval(e), n()
            }, 10)
          })
        })
      var nn = 'undefined' != typeof document ? document.currentScript : null,
        en = J(function () {
          if (nn) return nn
          if (
            (nn = (function () {
              try {
                var n = (function () {
                    try {
                      throw new Error('_')
                    } catch (n) {
                      return n.stack || ''
                    }
                  })(),
                  e = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(n),
                  t = e && e[1]
                if (!t) return
                for (
                  var r = 0, o = [].slice.call(document.getElementsByTagName('script')).reverse();
                  r < o.length;
                  r++
                ) {
                  var i = o[r]
                  if (i.src && i.src === t) return i
                }
              } catch (n) {}
            })())
          )
            return nn
          throw new Error('Can not determine current script')
        }),
        tn = L()
      function rn(n) {
        void 0 === n && (n = window)
        var e = '__post_robot_10_0_46__'
        return n !== window ? n[e] : (n[e] = n[e] || {})
      }
      J(function () {
        var n
        try {
          n = en()
        } catch (n) {
          return tn
        }
        var e = n.getAttribute('data-uid')
        if (e && 'string' == typeof e) return e
        if ((e = n.getAttribute('data-uid-auto')) && 'string' == typeof e) return e
        if (n.src) {
          var t = (function (n) {
            for (var e = '', t = 0; t < n.length; t++) {
              var r = n[t].charCodeAt(0) * t
              n[t + 1] && (r += n[t + 1].charCodeAt(0) * (t - 1)),
                (e += String.fromCharCode(97 + (Math.abs(r) % 26)))
            }
            return e
          })(JSON.stringify({ src: n.src, dataset: n.dataset }))
          e = 'uid_' + t.slice(t.length - 30)
        } else e = L()
        return n.setAttribute('data-uid-auto', e), e
      })
      var on = function () {
        return {}
      }
      function an(n, e) {
        return (
          void 0 === n && (n = 'store'),
          void 0 === e && (e = on),
          G(rn(), n, function () {
            var n = e()
            return {
              has: function (e) {
                return n.hasOwnProperty(e)
              },
              get: function (e, t) {
                return n.hasOwnProperty(e) ? n[e] : t
              },
              set: function (e, t) {
                return (n[e] = t), t
              },
              del: function (e) {
                delete n[e]
              },
              getOrSet: function (e, t) {
                return G(n, e, t)
              },
              reset: function () {
                n = e()
              },
              keys: function () {
                return Object.keys(n)
              },
            }
          })
        )
      }
      var un,
        cn = function () {}
      function sn() {
        var n = rn()
        return (n.WINDOW_WILDCARD = n.WINDOW_WILDCARD || new cn()), n.WINDOW_WILDCARD
      }
      function fn(n, e) {
        return (
          void 0 === n && (n = 'store'),
          void 0 === e && (e = on),
          an('windowStore').getOrSet(n, function () {
            var t = new M(),
              r = function (n) {
                return t.getOrSet(n, e)
              }
            return {
              has: function (e) {
                return r(e).hasOwnProperty(n)
              },
              get: function (e, t) {
                var o = r(e)
                return o.hasOwnProperty(n) ? o[n] : t
              },
              set: function (e, t) {
                return (r(e)[n] = t), t
              },
              del: function (e) {
                delete r(e)[n]
              },
              getOrSet: function (e, t) {
                return G(r(e), n, t)
              },
            }
          })
        )
      }
      function dn() {
        return an('instance').getOrSet('instanceID', L)
      }
      function ln(n, e) {
        var t = e.domain,
          r = fn('helloPromises'),
          o = r.get(n)
        o && o.resolve({ domain: t })
        var i = z.resolve({ domain: t })
        return r.set(n, i), i
      }
      function hn(n, e) {
        return (0, e.send)(
          n,
          'postrobot_hello',
          { instanceID: dn() },
          { domain: '*', timeout: -1 },
        ).then(function (e) {
          var t = e.origin,
            r = e.data.instanceID
          return ln(n, { domain: t }), { win: n, domain: t, instanceID: r }
        })
      }
      function wn(n, e) {
        var t = e.send
        return fn('windowInstanceIDPromises').getOrSet(n, function () {
          return hn(n, { send: t }).then(function (n) {
            return n.instanceID
          })
        })
      }
      function vn(n) {
        fn('knownWindows').set(n, !0)
      }
      function pn(n) {
        return 'object' == typeof n && null !== n && 'string' == typeof n.__type__
      }
      function mn(n) {
        return void 0 === n
          ? 'undefined'
          : null === n
            ? 'null'
            : Array.isArray(n)
              ? 'array'
              : 'function' == typeof n
                ? 'function'
                : 'object' == typeof n
                  ? n instanceof Error
                    ? 'error'
                    : 'function' == typeof n.then
                      ? 'promise'
                      : '[object RegExp]' === {}.toString.call(n)
                        ? 'regex'
                        : '[object Date]' === {}.toString.call(n)
                          ? 'date'
                          : 'object'
                  : 'string' == typeof n
                    ? 'string'
                    : 'number' == typeof n
                      ? 'number'
                      : 'boolean' == typeof n
                        ? 'boolean'
                        : void 0
      }
      function yn(n, e) {
        return { __type__: n, __val__: e }
      }
      var gn,
        _n =
          (((un = {}).function = function () {}),
          (un.error = function (n) {
            return yn('error', { message: n.message, stack: n.stack, code: n.code, data: n.data })
          }),
          (un.promise = function () {}),
          (un.regex = function (n) {
            return yn('regex', n.source)
          }),
          (un.date = function (n) {
            return yn('date', n.toJSON())
          }),
          (un.array = function (n) {
            return n
          }),
          (un.object = function (n) {
            return n
          }),
          (un.string = function (n) {
            return n
          }),
          (un.number = function (n) {
            return n
          }),
          (un.boolean = function (n) {
            return n
          }),
          (un.null = function (n) {
            return n
          }),
          (un[void 0] = function (n) {
            return yn('undefined', n)
          }),
          un),
        bn = {},
        Wn =
          (((gn = {}).function = function () {
            throw new Error('Function serialization is not implemented; nothing to deserialize')
          }),
          (gn.error = function (n) {
            var e = n.stack,
              t = n.code,
              r = n.data,
              o = new Error(n.message)
            return (o.code = t), r && (o.data = r), (o.stack = e + '\n\n' + o.stack), o
          }),
          (gn.promise = function () {
            throw new Error('Promise serialization is not implemented; nothing to deserialize')
          }),
          (gn.regex = function (n) {
            return new RegExp(n)
          }),
          (gn.date = function (n) {
            return new Date(n)
          }),
          (gn.array = function (n) {
            return n
          }),
          (gn.object = function (n) {
            return n
          }),
          (gn.string = function (n) {
            return n
          }),
          (gn.number = function (n) {
            return n
          }),
          (gn.boolean = function (n) {
            return n
          }),
          (gn.null = function (n) {
            return n
          }),
          (gn[void 0] = function () {}),
          gn),
        En = {}
      function xn() {
        for (var n = an('idToProxyWindow'), e = 0, t = n.keys(); e < t.length; e++) {
          var r = t[e]
          n.get(r).shouldClean() && n.del(r)
        }
      }
      function jn(n, e) {
        var t = e.send,
          r = e.id,
          o = void 0 === r ? L() : r,
          i = n.then(function (n) {
            if (h(n)) return w(n).name
          }),
          a = n.then(function (n) {
            if (g(n)) throw new Error('Window is closed, can not determine type')
            return s(n) ? 'popup' : 'iframe'
          })
        i.catch(K), a.catch(K)
        var u = function () {
          return n.then(function (n) {
            if (!g(n)) return h(n) ? w(n).name : i
          })
        }
        return {
          id: o,
          getType: function () {
            return a
          },
          getInstanceID: U(function () {
            return n.then(function (n) {
              return wn(n, { send: t })
            })
          }),
          close: function () {
            return n.then(x)
          },
          getName: u,
          focus: function () {
            return n.then(function (n) {
              n.focus()
            })
          },
          isClosed: function () {
            return n.then(function (n) {
              return g(n)
            })
          },
          setLocation: function (e, t) {
            return (
              void 0 === t && (t = {}),
              n.then(function (n) {
                var r = window.location.protocol + '//' + window.location.host,
                  o = t.method,
                  i = void 0 === o ? 'get' : o,
                  a = t.body
                if (0 === e.indexOf('/')) e = '' + r + e
                else if (!e.match(/^https?:\/\//) && 0 !== e.indexOf(r))
                  throw new Error(
                    'Expected url to be http or https url, or absolute path, got ' +
                      JSON.stringify(e),
                  )
                if ('post' === i)
                  return u().then(function (n) {
                    if (!n) throw new Error('Can not post to window without target name')
                    !(function (n) {
                      var e = n.url,
                        t = n.target,
                        r = n.body,
                        o = n.method,
                        i = void 0 === o ? 'post' : o,
                        a = document.createElement('form')
                      if (
                        (a.setAttribute('target', t),
                        a.setAttribute('method', i),
                        a.setAttribute('action', e),
                        (a.style.display = 'none'),
                        r)
                      )
                        for (var u = 0, c = Object.keys(r); u < c.length; u++) {
                          var s,
                            f = c[u],
                            d = document.createElement('input')
                          d.setAttribute('name', f),
                            d.setAttribute('value', null == (s = r[f]) ? void 0 : s.toString()),
                            a.appendChild(d)
                        }
                      Q().appendChild(a), a.submit(), Q().removeChild(a)
                    })({ url: e, target: n, method: i, body: a })
                  })
                if ('get' !== i) throw new Error('Unsupported method: ' + i)
                if (h(n))
                  try {
                    if (n.location && 'function' == typeof n.location.replace)
                      return void n.location.replace(e)
                  } catch (n) {}
                n.location = e
              })
            )
          },
          setName: function (e) {
            return n.then(function (n) {
              var t = h(n),
                r = E(n)
              if (!t) throw new Error('Can not set name for cross-domain window: ' + e)
              ;(w(n).name = e), r && r.setAttribute('name', e), (i = z.resolve(e))
            })
          },
        }
      }
      new z(function (n) {
        if (window.document && window.document.body) return n(window.document.body)
        var e = setInterval(function () {
          if (window.document && window.document.body)
            return clearInterval(e), n(window.document.body)
        }, 10)
      })
      var Sn = (function () {
        function n(n) {
          var e = n.send,
            t = n.win,
            r = n.serializedWindow
          ;(this.id = void 0),
            (this.isProxyWindow = !0),
            (this.serializedWindow = void 0),
            (this.actualWindow = void 0),
            (this.actualWindowPromise = void 0),
            (this.send = void 0),
            (this.name = void 0),
            (this.actualWindowPromise = new z()),
            (this.serializedWindow = r || jn(this.actualWindowPromise, { send: e })),
            an('idToProxyWindow').set(this.getID(), this),
            t && this.setWindow(t, { send: e })
        }
        var e = n.prototype
        return (
          (e.getID = function () {
            return this.serializedWindow.id
          }),
          (e.getType = function () {
            return this.serializedWindow.getType()
          }),
          (e.isPopup = function () {
            return this.getType().then(function (n) {
              return 'popup' === n
            })
          }),
          (e.setLocation = function (n, e) {
            var t = this
            return this.serializedWindow.setLocation(n, e).then(function () {
              return t
            })
          }),
          (e.getName = function () {
            return this.serializedWindow.getName()
          }),
          (e.setName = function (n) {
            var e = this
            return this.serializedWindow.setName(n).then(function () {
              return e
            })
          }),
          (e.close = function () {
            var n = this
            return this.serializedWindow.close().then(function () {
              return n
            })
          }),
          (e.focus = function () {
            var n = this,
              e = this.isPopup(),
              t = this.getName(),
              r = z.hash({ isPopup: e, name: t }).then(function (n) {
                var e = n.name
                n.isPopup && e && window.open('', e, 'noopener')
              }),
              o = this.serializedWindow.focus()
            return z.all([r, o]).then(function () {
              return n
            })
          }),
          (e.isClosed = function () {
            return this.serializedWindow.isClosed()
          }),
          (e.getWindow = function () {
            return this.actualWindow
          }),
          (e.setWindow = function (n, e) {
            var t = e.send
            ;(this.actualWindow = n),
              this.actualWindowPromise.resolve(this.actualWindow),
              (this.serializedWindow = jn(this.actualWindowPromise, { send: t, id: this.getID() })),
              fn('winToProxyWindow').set(n, this)
          }),
          (e.awaitWindow = function () {
            return this.actualWindowPromise
          }),
          (e.matchWindow = function (n, e) {
            var t = this,
              r = e.send
            return z.try(function () {
              return t.actualWindow
                ? n === t.actualWindow
                : z
                    .hash({
                      proxyInstanceID: t.getInstanceID(),
                      knownWindowInstanceID: wn(n, { send: r }),
                    })
                    .then(function (e) {
                      var o = e.proxyInstanceID === e.knownWindowInstanceID
                      return o && t.setWindow(n, { send: r }), o
                    })
            })
          }),
          (e.unwrap = function () {
            return this.actualWindow || this
          }),
          (e.getInstanceID = function () {
            return this.serializedWindow.getInstanceID()
          }),
          (e.shouldClean = function () {
            return Boolean(this.actualWindow && g(this.actualWindow))
          }),
          (e.serialize = function () {
            return this.serializedWindow
          }),
          (n.unwrap = function (e) {
            return n.isProxyWindow(e) ? e.unwrap() : e
          }),
          (n.serialize = function (e, t) {
            var r = t.send
            return xn(), n.toProxyWindow(e, { send: r }).serialize()
          }),
          (n.deserialize = function (e, t) {
            var r = t.send
            return xn(), an('idToProxyWindow').get(e.id) || new n({ serializedWindow: e, send: r })
          }),
          (n.isProxyWindow = function (n) {
            return Boolean(n && !W(n) && n.isProxyWindow)
          }),
          (n.toProxyWindow = function (e, t) {
            var r = t.send
            if ((xn(), n.isProxyWindow(e))) return e
            var o = e
            return fn('winToProxyWindow').get(o) || new n({ win: o, send: r })
          }),
          n
        )
      })()
      function kn(n, e, t, r, o) {
        var i = fn('methodStore'),
          a = an('proxyWindowMethods')
        Sn.isProxyWindow(r)
          ? a.set(n, { val: e, name: t, domain: o, source: r })
          : (a.del(n),
            (i.getOrSet(r, function () {
              return {}
            })[n] = { domain: o, name: t, val: e, source: r }))
      }
      function On(n, e) {
        var t = fn('methodStore'),
          r = an('proxyWindowMethods')
        return (
          t.getOrSet(n, function () {
            return {}
          })[e] || r.get(e)
        )
      }
      function Pn(n, e, t, r, o) {
        var i, a, u
        ;(a = (i = { on: o.on, send: o.send }).on),
          (u = i.send),
          an('builtinListeners').getOrSet('functionCalls', function () {
            return a('postrobot_method', { domain: '*' }, function (n) {
              var e = n.source,
                t = n.origin,
                r = n.data,
                o = r.id,
                i = r.name,
                a = On(e, o)
              if (!a)
                throw new Error(
                  "Could not find method '" + i + "' with id: " + r.id + ' in ' + l(window),
                )
              var c = a.source,
                s = a.domain,
                f = a.val
              return z
                .try(function () {
                  if (!b(s, t))
                    throw new Error(
                      "Method '" +
                        r.name +
                        "' domain " +
                        JSON.stringify($(a.domain) ? a.domain.source : a.domain) +
                        ' does not match origin ' +
                        t +
                        ' in ' +
                        l(window),
                    )
                  if (Sn.isProxyWindow(c))
                    return c.matchWindow(e, { send: u }).then(function (n) {
                      if (!n)
                        throw new Error(
                          "Method call '" +
                            r.name +
                            "' failed - proxy window does not match source in " +
                            l(window),
                        )
                    })
                })
                .then(
                  function () {
                    return f.apply({ source: e, origin: t }, r.args)
                  },
                  function (n) {
                    return z
                      .try(function () {
                        if (f.onError) return f.onError(n)
                      })
                      .then(function () {
                        var e, t
                        throw (
                          (n.stack &&
                            (n.stack =
                              'Remote call to ' +
                              i +
                              '(' +
                              (void 0 === (e = r.args) && (e = []),
                              ((t = e), [].slice.call(t))
                                .map(function (n) {
                                  return 'string' == typeof n
                                    ? "'" + n + "'"
                                    : void 0 === n
                                      ? 'undefined'
                                      : null === n
                                        ? 'null'
                                        : 'boolean' == typeof n
                                          ? n.toString()
                                          : Array.isArray(n)
                                            ? '[ ... ]'
                                            : 'object' == typeof n
                                              ? '{ ... }'
                                              : 'function' == typeof n
                                                ? '() => { ... }'
                                                : '<' + typeof n + '>'
                                })
                                .join(', ') + ') failed\n\n') +
                              n.stack),
                          n)
                        )
                      })
                  },
                )
                .then(function (n) {
                  return { result: n, id: o, name: i }
                })
            })
          })
        var c = t.__id__ || L()
        n = Sn.unwrap(n)
        var s = t.__name__ || t.name || r
        return (
          'string' == typeof s &&
            'function' == typeof s.indexOf &&
            0 === s.indexOf('anonymous::') &&
            (s = s.replace('anonymous::', r + '::')),
          Sn.isProxyWindow(n)
            ? (kn(c, t, s, n, e),
              n.awaitWindow().then(function (n) {
                kn(c, t, s, n, e)
              }))
            : kn(c, t, s, n, e),
          yn('cross_domain_function', { id: c, name: s })
        )
      }
      function An(n, e, t, r) {
        var o,
          i = r.on,
          a = r.send
        return (function (n, e) {
          void 0 === e && (e = bn)
          var t = JSON.stringify(n, function (n) {
            var t = this[n]
            if (pn(this)) return t
            var r = mn(t)
            if (!r) return t
            var o = e[r] || _n[r]
            return o ? o(t, n) : t
          })
          return void 0 === t ? 'undefined' : t
        })(
          t,
          (((o = {}).promise = function (t, r) {
            return (function (n, e, t, r, o) {
              return yn('cross_domain_zalgo_promise', {
                then: Pn(
                  n,
                  e,
                  function (n, e) {
                    return t.then(n, e)
                  },
                  r,
                  { on: o.on, send: o.send },
                ),
              })
            })(n, e, t, r, { on: i, send: a })
          }),
          (o.function = function (t, r) {
            return Pn(n, e, t, r, { on: i, send: a })
          }),
          (o.object = function (n) {
            return W(n) || Sn.isProxyWindow(n)
              ? yn('cross_domain_window', Sn.serialize(n, { send: a }))
              : n
          }),
          o),
        )
      }
      function Dn(n, e, t, r) {
        var o,
          i = r.send
        return (function (n, e) {
          if ((void 0 === e && (e = En), 'undefined' !== n))
            return JSON.parse(n, function (n, t) {
              if (pn(this)) return t
              var r, o
              if ((pn(t) ? ((r = t.__type__), (o = t.__val__)) : ((r = mn(t)), (o = t)), !r))
                return o
              var i = e[r] || Wn[r]
              return i ? i(o, n) : o
            })
        })(
          t,
          (((o = {}).cross_domain_zalgo_promise = function (n) {
            return (function (n, e, t) {
              return new z(t.then)
            })(0, 0, n)
          }),
          (o.cross_domain_function = function (t) {
            return (function (n, e, t, r) {
              var o = t.id,
                i = t.name,
                a = r.send,
                u = function (t) {
                  function r() {
                    var u = arguments
                    return Sn.toProxyWindow(n, { send: a })
                      .awaitWindow()
                      .then(function (n) {
                        var c = On(n, o)
                        if (c && c.val !== r) return c.val.apply({ source: window, origin: l() }, u)
                        var s = [].slice.call(u)
                        return t.fireAndForget
                          ? a(
                              n,
                              'postrobot_method',
                              { id: o, name: i, args: s },
                              { domain: e, fireAndForget: !0 },
                            )
                          : a(
                              n,
                              'postrobot_method',
                              { id: o, name: i, args: s },
                              { domain: e, fireAndForget: !1 },
                            ).then(function (n) {
                              return n.data.result
                            })
                      })
                      .catch(function (n) {
                        throw n
                      })
                  }
                  return (
                    void 0 === t && (t = {}),
                    (r.__name__ = i),
                    (r.__origin__ = e),
                    (r.__source__ = n),
                    (r.__id__ = o),
                    (r.origin = e),
                    r
                  )
                },
                c = u()
              return (c.fireAndForget = u({ fireAndForget: !0 })), c
            })(n, e, t, { send: i })
          }),
          (o.cross_domain_window = function (n) {
            return Sn.deserialize(n, { send: i })
          }),
          o),
        )
      }
      var In = {}
      function zn(n, e, t, r) {
        var o = r.on,
          i = r.send
        return z
          .try(function () {
            var r = fn().getOrSet(n, function () {
              return {}
            })
            return (
              (r.buffer = r.buffer || []),
              r.buffer.push(t),
              (r.flush =
                r.flush ||
                z.flush().then(function () {
                  if (g(n)) throw new Error('Window is closed')
                  var t,
                    a = An(n, e, (((t = {}).__post_robot_10_0_46__ = r.buffer || []), t), {
                      on: o,
                      send: i,
                    })
                  delete r.buffer
                  for (var u = Object.keys(In), c = [], s = 0; s < u.length; s++) {
                    var f = u[s]
                    try {
                      In[f](n, a, e)
                    } catch (n) {
                      c.push(n)
                    }
                  }
                  if (c.length === u.length)
                    throw new Error(
                      'All post-robot messaging strategies failed:\n\n' +
                        c
                          .map(function (n, e) {
                            return e + '. ' + Y(n)
                          })
                          .join('\n\n'),
                    )
                })),
              r.flush.then(function () {
                delete r.flush
              })
            )
          })
          .then(K)
      }
      function Cn(n) {
        return an('responseListeners').get(n)
      }
      function Nn(n) {
        an('responseListeners').del(n)
      }
      function Mn(n) {
        return an('erroredResponseListeners').has(n)
      }
      function Tn(n) {
        var e = n.name,
          t = n.win,
          r = n.domain,
          o = fn('requestListeners')
        if (('*' === t && (t = null), '*' === r && (r = null), !e))
          throw new Error('Name required to get request listener')
        for (var i = 0, a = [t, sn()]; i < a.length; i++) {
          var u = a[i]
          if (u) {
            var c = o.get(u)
            if (c) {
              var s = c[e]
              if (s) {
                if (r && 'string' == typeof r) {
                  if (s[r]) return s[r]
                  if (s.__domain_regex__)
                    for (var f = 0, d = s.__domain_regex__; f < d.length; f++) {
                      var l = d[f],
                        h = l.listener
                      if (b(l.regex, r)) return h
                    }
                }
                if (s['*']) return s['*']
              }
            }
          }
        }
      }
      function Rn(n, e, t, r) {
        var o = r.on,
          i = r.send,
          a = Tn({ name: t.name, win: n, domain: e }),
          u =
            'postrobot_method' === t.name && t.data && 'string' == typeof t.data.name
              ? t.data.name + '()'
              : t.name
        function c(r, a, c) {
          return z.flush().then(function () {
            if (!t.fireAndForget && !g(n))
              try {
                return zn(
                  n,
                  e,
                  {
                    id: L(),
                    origin: l(window),
                    type: 'postrobot_message_response',
                    hash: t.hash,
                    name: t.name,
                    ack: r,
                    data: a,
                    error: c,
                  },
                  { on: o, send: i },
                )
              } catch (n) {
                throw new Error(
                  'Send response message failed for ' + u + ' in ' + l() + '\n\n' + Y(n),
                )
              }
          })
        }
        return z
          .all([
            z.flush().then(function () {
              if (!t.fireAndForget && !g(n))
                try {
                  return zn(
                    n,
                    e,
                    {
                      id: L(),
                      origin: l(window),
                      type: 'postrobot_message_ack',
                      hash: t.hash,
                      name: t.name,
                    },
                    { on: o, send: i },
                  )
                } catch (n) {
                  throw new Error('Send ack message failed for ' + u + ' in ' + l() + '\n\n' + Y(n))
                }
            }),
            z
              .try(function () {
                if (!a)
                  throw new Error(
                    'No handler found for post message: ' +
                      t.name +
                      ' from ' +
                      e +
                      ' in ' +
                      window.location.protocol +
                      '//' +
                      window.location.host +
                      window.location.pathname,
                  )
                return a.handler({ source: n, origin: e, data: t.data })
              })
              .then(
                function (n) {
                  return c('success', n)
                },
                function (n) {
                  return c('error', null, n)
                },
              ),
          ])
          .then(K)
          .catch(function (n) {
            if (a && a.handleError) return a.handleError(n)
            throw n
          })
      }
      function Ln(n, e, t) {
        if (!Mn(t.hash)) {
          var r = Cn(t.hash)
          if (!r)
            throw new Error(
              'No handler found for post message ack for message: ' +
                t.name +
                ' from ' +
                e +
                ' in ' +
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname,
            )
          try {
            if (!b(r.domain, e))
              throw new Error('Ack origin ' + e + ' does not match domain ' + r.domain.toString())
            if (n !== r.win) throw new Error('Ack source does not match registered window')
          } catch (n) {
            r.promise.reject(n)
          }
          r.ack = !0
        }
      }
      function qn(n, e, t) {
        if (!Mn(t.hash)) {
          var o,
            i = Cn(t.hash)
          if (!i)
            throw new Error(
              'No handler found for post message response for message: ' +
                t.name +
                ' from ' +
                e +
                ' in ' +
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname,
            )
          if (!b(i.domain, e))
            throw new Error(
              'Response origin ' +
                e +
                ' does not match domain ' +
                ((o = i.domain),
                Array.isArray(o)
                  ? '(' + o.join(' | ') + ')'
                  : r(o)
                    ? 'RegExp(' + o.toString() + ')'
                    : o.toString()),
            )
          if (n !== i.win) throw new Error('Response source does not match registered window')
          Nn(t.hash),
            'error' === t.ack
              ? i.promise.reject(t.error)
              : 'success' === t.ack && i.promise.resolve({ source: n, origin: e, data: t.data })
        }
      }
      function Fn(n, e) {
        var t = e.on,
          r = e.send,
          o = an('receivedMessages')
        try {
          if (!window || window.closed || !n.source) return
        } catch (n) {
          return
        }
        var i = n.source,
          a = n.origin,
          u = (function (n, e, t, r) {
            var o,
              i = r.on,
              a = r.send
            try {
              o = Dn(e, t, n, { on: i, send: a })
            } catch (n) {
              return
            }
            if (o && 'object' == typeof o && null !== o) {
              var u = o.__post_robot_10_0_46__
              if (Array.isArray(u)) return u
            }
          })(n.data, i, a, { on: t, send: r })
        if (u) {
          vn(i)
          for (var c = 0; c < u.length; c++) {
            var s = u[c]
            if (o.has(s.id)) return
            if ((o.set(s.id, !0), g(i) && !s.fireAndForget)) return
            0 === s.origin.indexOf('file:') && (a = 'file://')
            try {
              'postrobot_message_request' === s.type
                ? Rn(i, a, s, { on: t, send: r })
                : 'postrobot_message_response' === s.type
                  ? qn(i, a, s)
                  : 'postrobot_message_ack' === s.type && Ln(i, a, s)
            } catch (n) {
              setTimeout(function () {
                throw n
              }, 0)
            }
          }
        }
      }
      function Bn(n, e, t) {
        if (!n) throw new Error('Expected name')
        if (('function' == typeof (e = e || {}) && ((t = e), (e = {})), !t))
          throw new Error('Expected handler')
        var r = (function n(e, t) {
          var r = e.name,
            o = e.win,
            i = e.domain,
            a = fn('requestListeners')
          if (!r || 'string' != typeof r) throw new Error('Name required to add request listener')
          if (o && '*' !== o && Sn.isProxyWindow(o)) {
            var u = o.awaitWindow().then(function (e) {
              return n({ name: r, win: e, domain: i }, t)
            })
            return {
              cancel: function () {
                u.then(function (n) {
                  return n.cancel()
                }, K)
              },
            }
          }
          var c = o
          if (Array.isArray(c)) {
            for (var s = [], f = 0, d = c; f < d.length; f++)
              s.push(n({ name: r, domain: i, win: d[f] }, t))
            return {
              cancel: function () {
                for (var n = 0; n < s.length; n++) s[n].cancel()
              },
            }
          }
          if (Array.isArray(i)) {
            for (var l = [], h = 0, w = i; h < w.length; h++)
              l.push(n({ name: r, win: c, domain: w[h] }, t))
            return {
              cancel: function () {
                for (var n = 0; n < l.length; n++) l[n].cancel()
              },
            }
          }
          var v = Tn({ name: r, win: c, domain: i })
          ;(c && '*' !== c) || (c = sn())
          var p = (i = i || '*').toString()
          if (v)
            throw c && i
              ? new Error(
                  'Request listener already exists for ' +
                    r +
                    ' on domain ' +
                    i.toString() +
                    ' for ' +
                    (c === sn() ? 'wildcard' : 'specified') +
                    ' window',
                )
              : c
                ? new Error(
                    'Request listener already exists for ' +
                      r +
                      ' for ' +
                      (c === sn() ? 'wildcard' : 'specified') +
                      ' window',
                  )
                : i
                  ? new Error(
                      'Request listener already exists for ' + r + ' on domain ' + i.toString(),
                    )
                  : new Error('Request listener already exists for ' + r)
          var m,
            y,
            g = a.getOrSet(c, function () {
              return {}
            }),
            _ = G(g, r, function () {
              return {}
            })
          return (
            $(i)
              ? (m = G(_, '__domain_regex__', function () {
                  return []
                })).push((y = { regex: i, listener: t }))
              : (_[p] = t),
            {
              cancel: function () {
                delete _[p],
                  y && (m.splice(m.indexOf(y, 1)), m.length || delete _.__domain_regex__),
                  Object.keys(_).length || delete g[r],
                  c && !Object.keys(g).length && a.del(c)
              },
            }
          )
        })(
          { name: n, win: e.window, domain: e.domain || '*' },
          {
            handler: t || e.handler,
            handleError:
              e.errorHandler ||
              function (n) {
                throw n
              },
          },
        )
        return {
          cancel: function () {
            r.cancel()
          },
        }
      }
      function Hn(n, e, t) {
        'function' == typeof (e = e || {}) && ((t = e), (e = {}))
        var r,
          o = new z()
        return (
          (e.errorHandler = function (n) {
            r.cancel(), o.reject(n)
          }),
          (r = Bn(n, e, function (n) {
            if ((r.cancel(), o.resolve(n), t)) return t(n)
          })),
          (o.cancel = r.cancel),
          o
        )
      }
      In.postrobot_post_message = function (n, e, t) {
        0 === t.indexOf('file:') && (t = '*'), n.postMessage(e, t)
      }
      var Jn = function n(e, t, r, o) {
        var i = (o = o || {}).domain || '*',
          a = o.timeout || -1,
          u = o.timeout || 5e3,
          s = o.fireAndForget || !1
        return Sn.toProxyWindow(e, { send: n })
          .awaitWindow()
          .then(function (e) {
            return z
              .try(function () {
                if (
                  ((function (n, e, t) {
                    if (!n) throw new Error('Expected name')
                    if (t && 'string' != typeof t && !Array.isArray(t) && !$(t))
                      throw new TypeError(
                        'Can not send ' +
                          n +
                          '. Expected domain ' +
                          JSON.stringify(t) +
                          ' to be a string, array, or regex',
                      )
                    if (g(e)) throw new Error('Can not send ' + n + '. Target window is closed')
                  })(t, e, i),
                  (function (n, e) {
                    var t = _(e)
                    if (t) return t === n
                    if (e === n) return !1
                    if (
                      (function (n) {
                        void 0 === n && (n = window)
                        try {
                          if (n.top) return n.top
                        } catch (n) {}
                        if (c(n) === n) return n
                        try {
                          if (v(window, n) && window.top) return window.top
                        } catch (n) {}
                        try {
                          if (v(n, window) && window.top) return window.top
                        } catch (n) {}
                        for (
                          var e = 0,
                            t = (function n(e) {
                              for (var t = [], r = 0, o = p(e); r < o.length; r++) {
                                var i = o[r]
                                t.push(i)
                                for (var a = 0, u = n(i); a < u.length; a++) t.push(u[a])
                              }
                              return t
                            })(n);
                          e < t.length;
                          e++
                        ) {
                          var r = t[e]
                          try {
                            if (r.top) return r.top
                          } catch (n) {}
                          if (c(r) === r) return r
                        }
                      })(e) === e
                    )
                      return !1
                    for (var r = 0, o = p(n); r < o.length; r++) if (o[r] === e) return !0
                    return !1
                  })(window, e))
                )
                  return (function (n, e, t) {
                    void 0 === e && (e = 5e3), void 0 === t && (t = 'Window')
                    var r = (function (n) {
                      return fn('helloPromises').getOrSet(n, function () {
                        return new z()
                      })
                    })(n)
                    return (
                      -1 !== e &&
                        (r = r.timeout(e, new Error(t + ' did not load after ' + e + 'ms'))),
                      r
                    )
                  })(e, u)
              })
              .then(function (t) {
                return (function (n, e, t, r) {
                  var o = r.send
                  return z.try(function () {
                    return 'string' == typeof e
                      ? e
                      : z
                          .try(function () {
                            return (
                              t ||
                              hn(n, { send: o }).then(function (n) {
                                return n.domain
                              })
                            )
                          })
                          .then(function (n) {
                            if (!b(e, e))
                              throw new Error('Domain ' + Z(e) + ' does not match ' + Z(e))
                            return n
                          })
                  })
                })(e, i, (void 0 === t ? {} : t).domain, { send: n })
              })
              .then(function (o) {
                var i,
                  u,
                  c = o,
                  f =
                    'postrobot_method' === t && r && 'string' == typeof r.name ? r.name + '()' : t,
                  d = new z(),
                  h = t + '_' + L()
                if (!s) {
                  var w = { name: t, win: e, domain: c, promise: d }
                  !(function (n, e) {
                    an('responseListeners').set(n, e)
                  })(h, w)
                  var v = fn('requestPromises').getOrSet(e, function () {
                    return []
                  })
                  v.push(d),
                    d.catch(function () {
                      !(function (n) {
                        an('erroredResponseListeners').set(n, !0)
                      })(h),
                        Nn(h)
                    })
                  var p = (function (n) {
                      return fn('knownWindows').get(n, !1)
                    })(e)
                      ? 1e4
                      : 2e3,
                    m = a,
                    y = p,
                    _ = m,
                    b =
                      ((i = function () {
                        return g(e)
                          ? d.reject(
                              new Error(
                                'Window closed for ' +
                                  t +
                                  ' before ' +
                                  (w.ack ? 'response' : 'ack'),
                              ),
                            )
                          : w.cancelled
                            ? d.reject(new Error('Response listener was cancelled for ' + t))
                            : ((y = Math.max(y - 500, 0)),
                              -1 !== _ && (_ = Math.max(_ - 500, 0)),
                              w.ack || 0 !== y
                                ? 0 === _
                                  ? d.reject(
                                      new Error(
                                        'No response for postMessage ' +
                                          f +
                                          ' in ' +
                                          l() +
                                          ' in ' +
                                          m +
                                          'ms',
                                      ),
                                    )
                                  : void 0
                                : d.reject(
                                    new Error(
                                      'No ack for postMessage ' +
                                        f +
                                        ' in ' +
                                        l() +
                                        ' in ' +
                                        p +
                                        'ms',
                                    ),
                                  ))
                      }),
                      500,
                      (function n() {
                        u = setTimeout(function () {
                          i(), n()
                        }, 500)
                      })(),
                      {
                        cancel: function () {
                          clearTimeout(u)
                        },
                      })
                  d.finally(function () {
                    b.cancel(), v.splice(v.indexOf(d, 1))
                  }).catch(K)
                }
                return zn(
                  e,
                  c,
                  {
                    id: L(),
                    origin: l(window),
                    type: 'postrobot_message_request',
                    hash: h,
                    name: t,
                    data: r,
                    fireAndForget: s,
                  },
                  { on: Bn, send: n },
                ).then(
                  function () {
                    return s ? d.resolve() : d
                  },
                  function (n) {
                    throw new Error(
                      'Send request message failed for ' + f + ' in ' + l() + '\n\n' + Y(n),
                    )
                  },
                )
              })
          })
      }
      function Un(n, e, t) {
        return An(n, e, t, { on: Bn, send: Jn })
      }
      function Kn(n, e, t) {
        return Dn(n, e, t, { on: Bn, send: Jn })
      }
      function Yn(n) {
        return new Sn({ send: Jn, win: n })
      }
      function Zn(n) {
        return Sn.toProxyWindow(n, { send: Jn })
      }
      function $n() {
        var n, e, t, r
        rn().initialized ||
          ((rn().initialized = !0),
          (e = (n = { on: Bn, send: Jn }).on),
          (t = n.send),
          ((r = rn()).receiveMessage =
            r.receiveMessage ||
            function (n) {
              return Fn(n, { on: e, send: t })
            }),
          (function (n) {
            var e = n.on,
              t = n.send
            an().getOrSet('postMessageListener', function () {
              return (
                (n = window).addEventListener(
                  'message',
                  (r = function (n) {
                    !(function (n, e) {
                      var t = e.on,
                        r = e.send
                      z.try(function () {
                        var e = n.source || n.sourceElement,
                          o = n.origin || (n.originalEvent && n.originalEvent.origin),
                          i = n.data
                        if (('null' === o && (o = 'file://'), e)) {
                          if (!o) throw new Error('Post message did not have origin domain')
                          Fn({ source: e, origin: o, data: i }, { on: t, send: r })
                        }
                      })
                    })(n, { on: e, send: t })
                  }),
                ),
                {
                  cancel: function () {
                    n.removeEventListener('message', r)
                  },
                }
              )
              var n, r
            })
          })({ on: Bn, send: Jn }),
          (function (n) {
            var e = n.on,
              t = n.send
            an('builtinListeners').getOrSet('helloListener', function () {
              var n = e('postrobot_hello', { domain: '*' }, function (n) {
                  return ln(n.source, { domain: n.origin }), { instanceID: dn() }
                }),
                r = _()
              return r && hn(r, { send: t }).catch(function (n) {}), n
            })
          })({ on: Bn, send: Jn }))
      }
      function Gn() {
        var n
        !(function () {
          for (var n = an('responseListeners'), e = 0, t = n.keys(); e < t.length; e++) {
            var r = t[e],
              o = n.get(r)
            o && (o.cancelled = !0), n.del(r)
          }
        })(),
          (n = an().get('postMessageListener')) && n.cancel(),
          delete window.__post_robot_10_0_46__
      }
      var Qn = !0
      function Vn(n) {
        for (var e = 0, t = fn('requestPromises').get(n, []); e < t.length; e++)
          t[e]
            .reject(new Error('Window ' + (g(n) ? 'closed' : 'cleaned up') + ' before response'))
            .catch(K)
      }
      $n()
    },
  ])
})
